import { type PropsWithChildren, type HTMLProps } from 'react'
import { cn } from '#app/utils/misc'

export const TableRow = HTMLTableRowElement

export function Table({ children, ...restProps }: HTMLProps<HTMLTableElement>) {
  return (
    <div className="my-1 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden rounded-lg border border-gray-7 shadow">
            <table className="min-w-full divide-y divide-gray-7" {...restProps}>
              {children}
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export function TableHead({ children }: PropsWithChildren) {
  return (
    <thead className={`bg-accent-9 text-gray-1 dark:text-gray-12`}>
      <tr className="text-center">{children}</tr>
    </thead>
  )
}

export function TableHeadCell({
  children,
  className,
  ...restProps
}: HTMLProps<HTMLTableCellElement>) {
  return (
    <th
      scope="col"
      className={cn('text-body-sm px-4 py-2 font-medium uppercase', className)}
      {...restProps}
    >
      {children}
    </th>
  )
}

export function TableBody({ children }: PropsWithChildren) {
  return <tbody className="divide-y divide-gray-6">{children}</tbody>
}

export function TableBodyCell({
  children,
  className,
  ...restProps
}: HTMLProps<HTMLTableCellElement>) {
  return (
    <td className={cn('whitespace-nowrap px-4 py-2', className)} {...restProps}>
      {children}
    </td>
  )
}
